import useGetKBBPromoAmount from '~/hooks/vdp/selectors/useGetKBBPromoAmount';

export default function useShowKBBPromo() {
  const kbbPromoAmount = useGetKBBPromoAmount();

  return kbbPromoAmount !== 0;
}
